// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"a74042a5","879":"b803f9b6"}[chunkId] + ".chunk.js";
};